// extracted by mini-css-extract-plugin
module.exports = {"chatMarkdown":"ChatMarkdown_chatMarkdown__g7pvT","highlightedCode":"ChatMarkdown_highlightedCode__bi5SV","externalHost":"ChatMarkdown_externalHost__IgXQ7"};